import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${STYLE_CONSTS.UNIT_2};
`;
